import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";

export const FAQ = () => {
    const [open, setOpen] = useState(0);
    return (
        <div data-testid="faq-list" className="space-y-4">
            {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                    <div key={f.q} className="border border-amber-500/70 bg-[#0b0f16]/60 px-5 transition-colors duration-300 hover:border-amber-400 sm:px-6">
                        <button
                            type="button"
                            data-testid={`faq-question-${i + 1}`}
                            aria-expanded={isOpen}
                            onClick={() => setOpen(isOpen ? -1 : i)}
                            className="group flex w-full items-center gap-5 py-6 text-left sm:gap-8"
                        >
                            <span className="font-mono text-[11px] tracking-[0.25em] text-amber-500">
                                Q.0{i + 1}
                            </span>
                            <span className="flex-1 font-serif text-lg text-slate-100 transition-colors duration-300 group-hover:text-white sm:text-xl">
                                {f.q}
                            </span>
                            <Plus
                                size={16}
                                aria-hidden="true"
                                className={`shrink-0 transition-transform duration-300 ${isOpen ? "rotate-45 text-amber-400" : "text-slate-500"}`}
                            />
                        </button>
                        <AnimatePresence initial={false}>
                            {isOpen && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                                    className="overflow-hidden"
                                >
                                    <p
                                        data-testid={`faq-answer-${i + 1}`}
                                        className="max-w-2xl pb-7 pl-12 text-sm leading-relaxed text-slate-400 sm:pl-16"
                                    >
                                        {f.a}
                                    </p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
};
